import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxFormButton } from './ngx-form.interfaces';
export class NgxFormButtonsComponent {
   buttons: NgxFormButton[] = []
   item: any = {}
   classNames = 'btn btn-default'
   action: EventEmitter<any> = new EventEmitter()
/**
 * @param {?} type
 * @param {?} payload
 * @return {?}
 */
click(type, payload) {
    payload = payload || this.item
    this.action.emit({ type, payload: Object.assign({}, payload) })
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-form-buttons',
  template: `
    <button
        *ngFor="let button of buttons"
        class="{{button.classNames}} {{classNames}}"
        (click)="click(button.click.type, button.click.payload)"
        [type]="button.type || 'button'">
      {{ button.label || 'Submit'}}
    </button>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'buttons': [{ type: Input },],
'item': [{ type: Input },],
'classNames': [{ type: Input },],
'action': [{ type: Output },],
};
}

function NgxFormButtonsComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormButtonsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormButtonsComponent.ctorParameters;
/** @type {?} */
NgxFormButtonsComponent.propDecorators;
/** @type {?} */
NgxFormButtonsComponent.prototype.buttons;
/** @type {?} */
NgxFormButtonsComponent.prototype.item;
/** @type {?} */
NgxFormButtonsComponent.prototype.classNames;
/** @type {?} */
NgxFormButtonsComponent.prototype.action;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
